import { CartUpdateEvent } from '@theme/events';

for (const dialog of document.querySelectorAll('[data-yk-pairing]')) {
  const addButton = dialog.querySelector('[data-pairing-add]');
  const status = dialog.querySelector('[data-pairing-status]');
  const root = dialog.dataset.root.replace(/\/?$/, '/');
  const storageKey = `yk-pairing:${dialog.dataset.triggerId}:${dialog.dataset.productId}`;
  let shown = false;
  let checking = false;
  let busy = false;
  let variant;
  let returnFocus;
  try { shown = sessionStorage.getItem(storageKey) === 'shown'; } catch { /* Storage is optional. */ }

  async function readJSON(url, options = {}) {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || 'Please try again.');
    return data;
  }
  const hasProduct = (cart, id) => cart.items.some((item) => String(item.product_id) === String(id));

  // Listen only to successful product-form additions, never quantity edits or our own addition.
  document.addEventListener('cart:update', async (event) => {
    const data = event.detail?.data;
    if (shown || checking || data?.didError || data?.source !== 'product-form-component' ||
        String(data.productId) !== dialog.dataset.triggerId) return;
    checking = true;
    try {
      const [cart, product] = await Promise.all([
        readJSON(`${root}cart.js`), readJSON(`${dialog.dataset.productUrl}.js`),
      ]);
      if (!hasProduct(cart, dialog.dataset.triggerId) || hasProduct(cart, dialog.dataset.productId)) return;
      // If a pairing has options, let the shopper choose them on the product page.
      variant = product.variants.length === 1 ? product.variants.find((item) => item.available) : null;
      if (!product.available) return;
      if (variant) {
        dialog.querySelector('[data-pairing-price]').textContent = new Intl.NumberFormat(
          document.documentElement.lang || 'en-GB', { style: 'currency', currency: cart.currency }
        ).format(variant.price / 100);
      }
      addButton.textContent = variant ? 'Add to basket' : 'Choose options';
      // Allow Savor's scheduled drawer opening to finish before placing this dialog above it.
      await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      if (document.querySelector('.yk-pairing[open]')) return;
      returnFocus = document.activeElement;
      dialog.showModal();
      shown = true;
      try { sessionStorage.setItem(storageKey, 'shown'); } catch { /* Storage is optional. */ }
    } catch { /* A recommendation must never interrupt the original purchase. */ }
    finally { checking = false; }
  });

  dialog.querySelectorAll('[data-pairing-close]').forEach((button) => {
    button.addEventListener('click', () => dialog.close());
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
  });

  addButton.addEventListener('click', async () => {
    if (busy) return;
    if (!variant) { window.location.assign(dialog.dataset.productUrl); return; }
    busy = true;
    addButton.disabled = true;
    addButton.textContent = 'Adding…';
    status.textContent = '';
    let submitted = false;
    try {
      // Recheck the basket in case it changed in another tab while the recommendation was open.
      let cart = await readJSON(`${root}cart.js`);
      if (!hasProduct(cart, dialog.dataset.productId)) {
        const sections = [...new Set([...document.querySelectorAll('cart-items-component')]
          .map((item) => item.dataset.sectionId).filter(Boolean))].slice(0, 5);
        submitted = true;
        const added = await readJSON(`${root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }], sections, sections_url: window.location.pathname }),
        });
        cart = await readJSON(`${root}cart.js`);
        document.dispatchEvent(new CartUpdateEvent(cart, 'yk-basket-pairing', {
          source: 'yk-basket-pairing', itemCount: cart.item_count, sections: added.sections,
        }));
      }
      addButton.textContent = 'Added to your basket';
      status.textContent = 'Your pairing is in the basket. Enjoy!';
      dialog.querySelector('[data-pairing-close]').focus();
    } catch (error) {
      // Never repeat an uncertain POST automatically: it may already have added the item.
      if (submitted) {
        addButton.textContent = 'Check your basket';
        status.textContent = 'We could not confirm the addition. Close this message and check your basket before trying again.';
      } else {
        addButton.disabled = false;
        addButton.textContent = 'Try again';
        status.textContent = 'We could not reach your basket. Please try again.';
      }
    } finally { busy = false; }
  });
}